import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import SyncHistory from './SyncHistory'
import ActiveSyncs from './ActiveSyncs'
import SyncToolsRoutes from './SyncTools/Routes'

const DataSyncRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="/admin/data-sync/active" replace />} />
      <Route path="history" element={<SyncHistory />} />
      <Route path="active" element={<ActiveSyncs />} />
      <Route path="tools/*" element={<SyncToolsRoutes />} />

      {/* Legacy route redirects */}
      <Route path="dashboard" element={<Navigate to="/admin/data-sync/active" replace />} />
      <Route path="status" element={<Navigate to="/admin/data-sync/active" replace />} />
    </Routes>
  )
}

export default DataSyncRoutes